module.exports = __webpack_public_path__ + "static/img/quiz_title.7bc3e91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quiz_title.png
// module id = 1451
// module chunks = 0